import React from "react";
import {connect} from "react-redux";
import classNames from "classnames";
import style from "./style.module.scss";

const mapStateToProps = ({settings}) => ({settings});

@connect(mapStateToProps)
class Footer extends React.Component {
    render() {
        const {
            settings: {isContentNoMaxWidth}
        } = this.props;
        return (
            <div
                className={classNames(style.footer, {
                    [style.footerFullWidth]: isContentNoMaxWidth
                })}
            >
                <div className={style.inner}>
                    <div className="row">
                        <div className="col-md-8">
                            <p>&copy; 2019 Manak Waste Management Pvt. Ltd.</p>
                        </div>
                        <div className="col-md-4">
                            <div className={style.logo}>
                                <img src="/resources/images/cashify-logo.png" alt="Air UI"/>
                                <div className={style.logoName}>BULK SALES</div>
                                <div className={style.logoDescr}>Powered by Cashify</div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}

export default Footer;
